(function () {
  'use strict';

  var MODAL_SELECTOR = '[data-ugc-videos-modal]';
  var BLOCK_SELECTOR = '.ugc-videos-block';
  var BODY_OPEN_CLASS = 'ugc-videos-modal-open';

  function hoistModalsToBody() {
    var modals = document.querySelectorAll(MODAL_SELECTOR);
    for (var i = 0; i < modals.length; i++) {
      if (modals[i].parentElement !== document.body) {
        document.body.appendChild(modals[i]);
      }
    }
  }

  // Previews only play (and download) while they are on screen.
  function initPreviews() {
    var previews = document.querySelectorAll('[data-ugc-video-preview]');
    if (!previews.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    if (reduceMotion || saveData || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            var attempt = video.play();
            if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { rootMargin: '100px 0px', threshold: 0.25 }
    );

    for (var i = 0; i < previews.length; i++) {
      observer.observe(previews[i]);
    }
  }

  function init() {
    hoistModalsToBody();
    initPreviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function buildVideo(sources, alt) {
    var video = document.createElement('video');
    video.className = 'ugc-videos__video';
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.preload = 'auto';
    if (alt) {
      video.setAttribute('aria-label', alt);
    }
    for (var i = 0; i < sources.length; i++) {
      var src = sources[i];
      if (!src || !src.url) continue;
      var source = document.createElement('source');
      source.src = src.url;
      if (src.mime_type) source.type = src.mime_type;
      video.appendChild(source);
    }
    return video;
  }

  function openModal(modal, sources, alt) {
    var body = modal.querySelector('[data-ugc-videos-body]');
    if (!body) return;
    body.innerHTML = '';
    var video = buildVideo(sources, alt);
    body.appendChild(video);
    modal.hidden = false;
    document.body.classList.add(BODY_OPEN_CLASS);

    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        video.muted = true;
        video.play().catch(function () {});
      });
    }
  }

  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    var body = modal.querySelector('[data-ugc-videos-body]');
    if (body) {
      var video = body.querySelector('video');
      if (video) {
        try { video.pause(); } catch (e) {}
      }
      body.innerHTML = '';
    }
    modal.hidden = true;
    if (!document.querySelector(MODAL_SELECTOR + ':not([hidden])')) {
      document.body.classList.remove(BODY_OPEN_CLASS);
    }
  }

  function closeAllModals() {
    var modals = document.querySelectorAll(MODAL_SELECTOR);
    for (var i = 0; i < modals.length; i++) {
      closeModal(modals[i]);
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ugc-video-trigger]');
    if (trigger) {
      event.preventDefault();
      var modal = document.querySelector(MODAL_SELECTOR);
      if (!modal) return;
      var previewVideo = trigger.querySelector('video');
      var sources = [];
      if (previewVideo) {
        var srcEls = previewVideo.querySelectorAll('source');
        for (var i = 0; i < srcEls.length; i++) {
          if (srcEls[i].src) sources.push({ url: srcEls[i].src, mime_type: srcEls[i].type });
        }
        if (!sources.length && previewVideo.currentSrc) {
          sources.push({ url: previewVideo.currentSrc });
        }
      }
      if (!sources.length) return;
      openModal(modal, sources, trigger.dataset.videoAlt || '');
      return;
    }

    var closeBtn = event.target.closest('[data-ugc-videos-close]');
    if (closeBtn) {
      closeModal(closeBtn.closest(MODAL_SELECTOR));
      return;
    }

    var clickedModal = event.target.closest(MODAL_SELECTOR);
    if (clickedModal && event.target === clickedModal) {
      closeModal(clickedModal);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      closeAllModals();
    }
  });
})();
